import {
  Component,
  OnInit,
  OnDestroy,
  Inject,
  ElementRef, 
  ViewChild,
  ChangeDetectorRef
} from '@angular/core';



import {
  ActivatedRoute,
  Router
} from '@angular/router';

import {
  first
} from 'rxjs/operators';

import {
  MsalService
} from '@azure/msal-angular';

import {
  Currency,
  PricelistWms,
  RatiosWms,
  Service,
  User,
  Field,
  RateGroupWms,
  RateTypeWms,
  RateWms,
} from '../../models';

import {
  PricelistWmsService,
  ServiceService,
  AuthService,
  SidebarService,
  RateTypeService,
  LabelService
} from '../../providers';

import {
  getContextPath,
  getCurrencyOptions,
  getCurrencySymbol,
  getModelOption,
  getUtcDateTimestamp,
  getVatRates,
  isArrayNotEmpty,
  isStringSafeNotEmpty,
  naturalSort,
  setPricelistAdjustmentWms
} from '../../app/app.utils';

import {
  DEFAULT_CURRENCY_CODE,
  DEFAULT_LANGUAGE_CODE,
  PRICELIST_OFFICIAL_DEFAULT,
  WAREHOUSE_PARTNER_CODE_MAP,
  PRICELIST_SERVICE_CODES_LEGACY_DEFAULT
} from '../../app/app.const';


@Component({
  selector: 'biz-page-pricelist-wms',
  templateUrl: './pricelist-wms.component.html',
  styleUrls: [
    './pricelist-wms.component.scss'
  ],
  host: {
    class: 'biz-page'
  }
})
export class PricelistWmsComponent implements OnInit, OnDestroy {
  @ViewChild('serviceSearchInput') serviceSearchInput: ElementRef;
  @ViewChild('userSearchInput') userSearchInput: ElementRef;

  public pricelist: PricelistWms;
  public pricelistDomain: string = null;
  public pricelistIsClone: boolean;
  public pricelistIsEdit: boolean;
  public pricelistIsMarkup: boolean;
  public pricelistIsNew: boolean;
  public pricelistIsReadOnly: boolean;
  public filteredServices = [];
  public filteredUsers = [];
  public serviceSearchTerm = '';
  public userSearchTerm = '';
  public existingLabels: { [key: string]: number } = {};
  public freeNumbers: { [key: string]: number[] } = {};

  public currencyOptions: {
    zones: Currency[],
    preferred: Currency[],
    other: Currency[]
  };
  public currencyOptionActive: Currency;

  private rateTypesMap: { 
    [key: number]: RateTypeWms[] 
  } = {};
  
  private categoryMap: { 
    [key: number]: string | null 
  } = {};
  
  private excludedCodes: string[] = [];
  
  private allRates: any[] = [];

  private selectedCodes: { 
    [index: number]: { 
      [innerIndex: number]: string 
    } 
  } = {};
  
  private hasSameExtraSKU: boolean = false;
  
  private rateTypeParametersMap: { 
    [key: number]: { 
      [key: number]: string[] 
    } 
  } = {};

  private previousParametersMap: { 
    [key: number]: { 
      [key: number]: string 
    } 
  } = {};

  private previousRateTypesMap: { 
    [key: number]: { 
      [key: number]: string 
    } 
  } = {};
  
  private rateTypeCodesMap: { 
    [key: number]: { 
      [key: number]: string[] 
    } 
  } = {};
  
  private previousCategoryMap: { 
    [key: number]: string | null 
  } = {};
  
  private filteredRates: RateTypeWms[] = [];
  

  public currencyRateFieldShow: boolean = false;
  private wasExtraSKUSameFlag = false; 

  public languageCodeActiveLabel: string = (
    DEFAULT_LANGUAGE_CODE
  );

  public users: User[] = [];
  public partnerCodes: string[] = [];
  
  public showRefreshWarning: boolean;

  public services: Service[] = [];
  public vatRates: number[] = [];
  public rateGroups: RateGroupWms[] = [];
  public rateTypes: RateTypeWms[] = [];

  private authEmail: string;
  public isExtraSKUSameFlag: boolean = false;

  public usedCategories: string[] = [];

  public optionMap = {
    OrderFulfillment: ['OFPAP', 'ODFEW', 'SDCFG', 'SDADS'],
    OrderFulfillmentExtraSKU: ['OFASF'],
    ReverseLogistics: ['RLROP', 'RLFEW'],
    ReverseLogisticsExtraSKU: ['RLOFA'],
    WarehouseManagement: ['RGDSN', 'BUPBL', 'FTPPI','PALET', 'IODBR', 'IODPR', 'CCALL', 'LBHRT', 'PLRPL', 'BIZID', 'PACKA', 'OTHER'],
    Storage: ['CBMMF'],
  };

  private readonly standardRateGroupLabels: { [key: string]: string } = {
    'Order Fulfillment': 'Order Fulfillment',
    'Order Fulfillment Extra SKU': 'Order Fulfillment Extra SKU',
    'Reverse Logistics': 'Reverse Logistics',
    'Reverse Logistics Extra SKU': 'Reverse Logistics Extra SKU',
    'Warehouse Actions': 'Warehouse Actions',
    'Storage': 'Storage'
  };

  public fieldsOrderFulfillment: Field[] = [
    {
      label: 'Select Rate',
      icon: 'pricetags-outline',
      valueKey: 'type',
      valueType: 'string',
      values: [],
      valueLabels: [],
      isModifier: true,
      disabled: []
    },
    {
      label: 'Parameters',
      icon: 'pricetags-outline',
      valueKey: 'parameter',
      valueType: 'string',
      valueLabels: [],
      values: [],
      modifierValues: ['OFPAP','OFASF', 'BIZID', 'SDCFG', 'SDADS', 'RGDSN', 'FTPPI', 'CBMMF', 'CCALL', 'LBHRT', 'RLROP', 'RLOFA', 'PLRPL'],
      isModifier: true
    },
    {
      label: 'Max Item(s)',
      icon: 'pricetags-outline',
      valueKey: 'maxItems',
      valueType: 'string',
      modifierValues: []
    },
    {
      label: 'Max Weight (kg)',
      icon: 'pricetags-outline',
      valueKey: 'maxWeight',
      valueType: 'string',
      valueLabels: [],
      values: [],
      modifierValues: ['ODFEW', 'RLFEW'],
      isModifier: true,
      disabled: []
    },
    {
      label: 'Increment (kg)',
      icon: 'pricetags-outline',
      valueKey: 'perWeight',
      valueType: 'string',
      valueLabels: [],
      values: [],
      modifierValues: ['ODFEW', 'RLFEW'],
      isModifier: true,
      disabled: []
    },
    {
      label: 'Code',
      icon: 'pricetags-outline',
      valueKey: 'code',
      valueType: 'number',
      valueLabels: [],
      values: [],
      isModifier: true,
      modifierValues: [ 
        'OFASF', 
        'BIZID', 
        'SDCFG', 
        'SDADS', 
        'RGDSN', 
        'FTPPI', 
        'CBMMF', 
        'CCALL', 
        'LBHRT', 
        'RLOFA',
        'PLRPL',
        'PACKA'
      ],
    },
    {
      label: 'Fee',
      icon: 'pricetags-outline',
      valueKey: 'fee',
      valueType: 'float',
      valueStep: 0.01,
      valueMin: 0.01,
      modifierValues: [
        'OFPAP', 
        'OFASF', 
        'BIZID', 
        'SDCFG', 
        'SDADS', 
        'RGDSN', 
        'FTPPI', 
        'CBMMF', 
        'CCALL', 
        'LBHRT', 
        'RLROP', 
        'RLOFA',
        'BUPBL',
        'PLRPL',
        'PALET', 
        'IODBR', 
        'IODPR', 
        'ODFEW',
        'RLFEW',
        'PACKA'
      ],
    },
    {
      label: 'Description',
      icon: 'pricetags-outline',
      valueKey: 'description',
      valueType: 'string',
      modifierValues: [
        'OFPAP', 
        'OFASF', 
        'BIZID', 
        'SDCFG', 
        'SDADS', 
        'RGDSN', 
        'FTPPI', 
        'CBMMF', 
        'CCALL', 
        'LBHRT', 
        'RLROP', 
        'BUPBL',
        'RLOFA',
        'PLRPL', 
        'PALET', 
        'IODBR', 
        'IODPR', 
        'ODFEW',
        'RLFEW',
        'PACKA',
        'OTHER'
      ],
      fieldType: 'textarea'
    }
  ];

  public itemEmptyOrderFulfillment: RateWms = {
    type: null,
    parameter: null,
    maxItems: null,
    maxWeight: null,
    perWeight: null,
    code: null,
    fee: null,
    description: null
  };

  public itemsOrderFulfillment: RateWms[] = [];

  public category: string = '';

  public hasOFPAP: boolean = false;
  public hasOFASF: boolean = false;

  private readonly reverseLogisticsExtraWeightMaxWeightLabel = '≥ 5 KG';
  private readonly reverseLogisticsExtraWeightPerWeightLabel = 'Per 5 KG';

  public constructor(
    @Inject(
      'Window'
    ) private window: Window,
    private router: Router,
    private route: ActivatedRoute,
    private msalService: MsalService,
    private authService: AuthService,
    private pricelistWmsService: PricelistWmsService,
    private serviceService: ServiceService,
    private sidebarService: SidebarService,
    private cdr: ChangeDetectorRef,
    private rateTypeService: RateTypeService,
    private labelService: LabelService
  ) {}

  public get pricelistDomainIsCosts(): boolean {
    return (
      this.pricelistDomain ===
      'costs'
    );
  }

  private getRateTypeCode(rate: any): string | null {
    if (!rate?.type) {
      return null;
    }

    if (typeof rate.type === 'string') {
      const matchingRateType = (this.allRates || []).find(
        rateType => (
          rateType.code === rate.type ||
          rateType._id === rate.type
        )
      );

      return matchingRateType?.code || rate.type;
    }

    const matchingRateType = (this.allRates || []).find(
      rateType => rateType._id === rate.type._id
    );

    return rate.type.code || matchingRateType?.code || null;
  }

  private getRateTypeParameterLabel(
    rateTypeCode: string | null,
    field: 'parameters' | 'maxWeight' | 'perWeight',
    value: any
  ): string | null {
    if (!value) {
      return null;
    }

    if (typeof value === 'object') {
      return value.label || null;
    }

    const rateType = (this.allRates || []).find(
      item => item.code === rateTypeCode
    );

    const matchingParameter = (rateType?.[field] || []).find(
      parameter => (
        parameter.label === value ||
        (parameter as any)._id === value
      )
    );

    return matchingParameter?.label || value;
  }

  private getRateFeeValue(rate: any): number | null {
    if (typeof rate?.fee === 'number') {
      return rate.fee;
    }

    return (
      typeof rate?.fee?.value === 'number' ?
        rate.fee.value :
        null
    );
  }

  private getUsedRateTypeCodes(
    excludeGroupIndex?: number,
    excludeRateIndex?: number
  ): string[] {
    const usedCodes = new Set<string>();
  
    (this.pricelist?.rateGroups || []).forEach((group, groupIndex) => {
      (group?.rates || []).forEach((rate, rateIndex) => {
        if (
          groupIndex === excludeGroupIndex &&
          rateIndex === excludeRateIndex
        ) {
          return;
        }
  
        const code = this.getRateTypeCode(rate);
        if (code) {
          usedCodes.add(code);
        }
      });
    });
  
    return Array.from(usedCodes);
  }
  
  private getRateTypeOptionDisabledMatrix(
    groupIndex: number,
    rateTypes: RateTypeWms[]
  ): boolean[][] {
    const rates = this.pricelist?.rateGroups?.[groupIndex]?.rates || [];
    const rowCount = rates.length + 1;

    return Array.from({ length: rowCount }, (_, rateIndex) => {
      const usedElsewhere = new Set(
        this.getUsedRateTypeCodes(groupIndex, rateIndex)
      );

      return rateTypes.map(rateType => usedElsewhere.has(rateType.code));
    });
  }

  private getAllowedRateTypeCodes(): string[] {
    return ([] as string[]).concat(...Object.values(this.optionMap));
  }

  private getFilteredWmsRateTypes(): RateTypeWms[] {
    const allowedCodes = new Set(this.getAllowedRateTypeCodes());
    return (this.allRates || []).filter(rateType => allowedCodes.has(rateType.code));
  }

  private isGroupReverseLogistics(index: number): boolean {
    const rateGroup = this.pricelist?.rateGroups?.[index];
    if (!rateGroup?.rates) {
      return false;
    }

    return rateGroup.rates.some(rate => this.isRLROP(this.getRateTypeCode(rate)));
  }

  private isGroupReverseLogisticsExtraSku(index: number): boolean {
    const rateGroup = this.pricelist?.rateGroups?.[index];
    if (!rateGroup?.rates) {
      return false;
    }

    return rateGroup.rates.some(rate => this.isRLOFA(this.getRateTypeCode(rate)));
  }

  public getIsExtraSKUSameFlag(index: number): boolean {
    const rateGroup: any = this.pricelist?.rateGroups?.[index];
    return !!rateGroup?.isExtraSKUSameFlag;
  }

  private setIsExtraSKUSameFlag(index: number, value: boolean): void {
    const rateGroup: any = this.pricelist?.rateGroups?.[index];
    if (!rateGroup) {
      return;
    }

    rateGroup.isExtraSKUSameFlag = value;
  }

  private getCategoryFromRateCodes(rateCodes: string[]): string | null {
    if (!Array.isArray(rateCodes) || rateCodes.length === 0) {
      return null;
    }

    if (rateCodes.some(code => ['RLROP', 'RLFEW'].includes(code))) {
      return 'Reverse Logistics';
    }

    if (rateCodes.some(code => code === 'RLOFA')) {
      return 'Reverse Logistics Extra SKU';
    }

    if (rateCodes.some(code => code === 'OFASF')) {
      return 'Order Fulfillment Extra SKU';
    }

    if (rateCodes.some(code => ['OFPAP', 'ODFEW', 'SDCFG', 'SDADS'].includes(code))) {
      return 'Order Fulfillment';
    }

    if (rateCodes.some(code => ['CBMMF'].includes(code))) {
      return 'Storage';
    }

    if (rateCodes.some(code => ['RGDSN', 'BUPBL', 'FTPPI','PALET', 'IODBR', 'IODPR', 'CCALL', 'LBHRT', 'PLRPL', 'BIZID', 'PACKA'].includes(code))) {
      return 'Warehouse Actions';
    }

    return null;
  }

  private setStandardRateGroupLabel(index: number): void {
    const rateGroup = this.pricelist?.rateGroups?.[index];

    if (!rateGroup?.rates) {
      return;
    }

    const rateCodes = rateGroup.rates
      .map(rate => this.getRateTypeCode(rate))
      .filter(Boolean) as string[];

    const category = this.getCategoryFromRateCodes(rateCodes);

    if (!category) {  
      delete (rateGroup as any).categoryKey;
      return;
    }

    const standardLabel = this.standardRateGroupLabels[category];

    (rateGroup as any).categoryKey = category;

    if (standardLabel) {
      rateGroup.label = standardLabel;
    }
  }

  private isRLROP(rateType: string | null | undefined): boolean {
    return String(rateType) === 'RLROP';
  }

  private isRLOFA(rateType: string | null | undefined): boolean {
    return String(rateType) === 'RLOFA';
  }

  private isRLFEW(rateType: string | null | undefined): boolean {
    return String(rateType) === 'RLFEW';
  }

  private disablesSameCalculationToggle(
    parameter: string | { label?: string } | null | undefined
  ): boolean {
    const label = (
      typeof parameter === 'string'
        ? parameter
        : parameter?.label
    );

    const normalizedLabel = String(label || '')
      .trim()
      .toLowerCase();

    return [
      'per shipment',
      '≥ 5 kg'
    ].includes(normalizedLabel);
  }

  private isReverseLogisticsExtraSkuRate(rateType: string | null | undefined): boolean {
    return this.isRLOFA(rateType);
  }

  private hasAvailableCodes(codes: any): boolean {
    return Array.isArray(codes) && codes.length > 0;
  }

  public hasMirrorableReverseLogisticsRateInGroup(index: number): boolean {
    const rateGroup = this.pricelist?.rateGroups?.[index];

    if (!rateGroup?.rates) {
      return false;
    }

    return rateGroup.rates.some(rate => {
      const rateType = this.getRateTypeCode(rate);

      return (
        rateType === 'RLROP' ||
        rateType === 'RLOFA'
      );
    });
  }

  private hasReverseLogisticsExtraSkuRate(): boolean {
    return this.pricelist?.rateGroups?.some(rateGroup =>
      rateGroup?.rates?.some(rate => {
        const rateType = typeof rate?.type === 'string'
          ? rate.type
          : rate?.type?.code;

        return this.isReverseLogisticsExtraSkuRate(rateType);
      })
    ) || false;
  }

  public shouldDisableSameCalculation(index: number): boolean {
    const rateGroup = this.pricelist?.rateGroups?.[index];

    if (!rateGroup?.rates) {
      return false;
    }

    return rateGroup.rates.some(rate => {
      const rateType = this.getRateTypeCode(rate);

      return (
        (
          this.isRLROP(rateType) ||
          this.isRLOFA(rateType)
        ) &&
        this.disablesSameCalculationToggle(rate.parameter)
      );
    });
  }
  
  public get pricelistLabel(): string {
    if (
      !this.languageCodeActiveLabel ||
      (
        this.languageCodeActiveLabel ===
        DEFAULT_LANGUAGE_CODE
      )
    ) {
      return (
        this.pricelist
            .label
      );
    }

    const translationActive = (
      (
        Array
          .isArray(
            this.pricelist
                .translations
          )
      ) ?
        (
          this.pricelist
              .translations
              .find(
                translation => (
                  (
                    'label' ===
                    (
                      translation
                        .key
                    )
                  ) &&
                  (
                    this.languageCodeActiveLabel ===
                    (
                      translation
                        .languageCode
                    )
                  )
                )
              )
        ) :
        undefined
    );

    return (
      translationActive ?
        (
          translationActive
            .value
        ) :
        ''
    );
  }

  public get pricelistServicesActive(): Service[] {
    if (
      !(
        (
          Array
            .isArray(
              this.services
            )
        ) &&
        (
          isArrayNotEmpty(
            this.pricelist
                .services
          )
        )
      )
    ) {
      return [];
    }

    return (
      this.services
          .filter(
            service => (
              (
                (
                  <Service[]>(
                    this.pricelist
                        .services
                  )
                )
                .map(
                  pricelistService => (
                    pricelistService
                      ._id
                  )
                )
                .includes(
                  service
                    ._id
                )
              )
            )
          )
    );
  }

  public get pricelistUsersActive(): User[] {
    if (
      !(
        (
          Array
            .isArray(
              this.users
            )
        ) &&
        (
          isArrayNotEmpty(
            this.pricelist
                .users
          )
        )
      )
    ) {
      return [];
    }

    return (
      this.users
          .filter(
            user => (
              (
                (
                  <User[]>(
                    this.pricelist
                        .users
                  )
                )
                .map(
                  pricelistUser => (
                    pricelistUser
                      ._id
                  )
                )
                .includes(
                  user
                    ._id
                )
              )
            )
          )
    );
  }

  public async ngOnInit() {
    this.setAuthEmail();
    this.setVatRates();

    await this.setServices();
    await this.setUsers();

    this.filteredServices = this.services;
    this.filteredUsers = this.users;

    await this.setPartnerCodes();

    await this.setRateTypes();

    this.setPricelistDomain();
    await this.setPricelist();
    

    this.currencyOptions = (
      getCurrencyOptions()
    );

    await this.setPricelistIsClone();
    await this.setPricelistIsMarkup();

    if (
      !this.pricelistDomainIsCosts &&
      this.pricelist?.partnerCode &&
      !this.pricelist?.terms?.trim()
    ) {
      await this.setDefaultBizPayTerms();
    }

    this.setPricelistIsEdit();
    this.setPricelistIsReadOnly();
    this.setSidebarActiveState();

    this.setCurrencyOptionActive(
      this.pricelist
          .currencyCode
    );
    this.transformRates([this.pricelist]);

    await this.initializeRateTypesMap();
  }

  public ngOnDestroy() {
    this.sidebarService
        .clearActiveState();
  }

  removeLabel(label: string): void {
    this.labelService.removeLabelFromExistingLabels(label);
  }

  private async initializeRateTypesMap() {
    for (let i = 0; i < this.pricelist.rateGroups.length; i++) {
        this.rateTypesMap[i] = await this.setRateTypes();
    }
    this.updateExcludedAndSelectedCodes();
}

private async setDefaultBizPayTerms(): Promise<void> {
    if (
      this.pricelist?.terms &&
      this.pricelist.terms.trim().length > 0
    ) {
      return;
    }
    
    if (!this.warehouseSelected) {
      return;
    }

    const warehouse = await this.pricelistWmsService
      .getWarehouseByCodePartner(this.warehouseSelected);

  const warehouseAddress = this.getWarehouseAddressLabel(warehouse);

  this.pricelist.terms = `General Information & Introduction Guidelines and Billing Policy for ${warehouseAddress}

Standard Inbound Conditions & Timeframe
The standard inbound processing timeframe is 1 to 2 working days and applies to shipments that meet the following conditions combined:
- Up to 5,000 items per inbound
- Up to 2–3 SKUs per inbound
- Up to 4 Euro pallets (120 × 80 × 220 cm) or boxed deliveries of equivalent volume
- Products packed in boxes, sorted per SKU, properly wrapped, and not scattered
- Properly prepared and documented shipments
- No special handling requirements, including additional instruction labels, relabeling, sorting, or other non-standard processing

For inbound shipments that exceed the above criteria, involve higher complexity, or require additional handling, an estimated processing timeframe and any applicable labour/introduction fees will be provided within 1 working day from the goods’ arrival at the warehouse.

During peak seasons or for exceptionally large or complex shipments, tailored handling estimates may also apply to ensure prompt and efficient processing.

The charges referred to in the above pricelist do not include VAT i.e., Value Added Tax.
For anything not clarified in this quote, our Basic Pricelist applies. Additionally, for any queries or questions which may arise, please consult our sales team # sales@bizcourier.eu or info@bizcourier.eu.`;
  }

  public onBack() {
    this.goBack();
  }

  public async addComponents() {
    this.hasSameExtraSKU = this.hasReverseLogisticsExtraSkuRate();
    const rateGroup = new RateGroupWms();
  
    this.pricelist
      .rateGroups
      .push(rateGroup);
  
    const index = this.pricelist
      .rateGroups
      .length - 1;

      
      this.pricelist
      .rateGroups[index].label = `WMS Rate Group - Draft ${index + 1}`
  
    this.rateTypesMap[index] = await this.setRateTypes();
  }

  private getLabelForGroup(index: number): string {
    return this.pricelist.rateGroups[index].label || ''; 
  }
  

  onRemoveRateGroup(
    index: number
  ): void {
    const removedLabel = this.getLabelForGroup(index);

    if (removedLabel) {
      this.removeLabel(removedLabel);
    }

    this.pricelist
      .rateGroups
      .splice(index, 1);
  
    let newRateTypesMap: { 
      [key: number]: RateTypeWms[] 
    } = {};
    
    let newCategoryMap: { 
      [key: number]: string | null 
    } = {};
    
    let newPreviousCategoryMap: { 
      [key: number]: string | null 
    } = {};
    
    let newIndex = 0;
    
    let newSelectedCodes: { 
      [key: number]: { 
        [innerIndex: number]: string 
      } 
    } = {};

    let newPreviousParametersMap: { 
      [key: number]: { 
        [key: number]: string 
      } 
    } = {};

    let newPreviousRateTypesMap: { 
      [key: number]: { 
        [key: number]: string 
      } 
    } = {};
  
    for (
      let i = 0; 
      i < this.pricelist.rateGroups.length + 1; 
      i++
    ) {
      if (
        i !== index
      ) {
        newRateTypesMap[newIndex] = this.rateTypesMap[i];
        newPreviousParametersMap[newIndex] = this.previousParametersMap[i];
        newPreviousRateTypesMap[newIndex] = this.previousRateTypesMap[i];
        
        if (
          this.selectedCodes[i]
        ) {
          newSelectedCodes[newIndex] = this.selectedCodes[i];
        }
        
        newIndex++;
      }
    }
  
    this.rateTypesMap = newRateTypesMap;
    this.selectedCodes = newSelectedCodes;
    this.previousParametersMap = newPreviousParametersMap;
    this.previousRateTypesMap = newPreviousRateTypesMap;
    
    this.updateExcludedAndSelectedCodes();

    this.hasOFPAP = this.isOFPAPSelected();
    this.hasOFASF = this.isOFASFSelected();

    this.pricelist.rateGroups.forEach((_, groupIndex) => {
      if (this.isGroupReverseLogistics(groupIndex) && !this.hasOFPAP) {
        this.setIsExtraSKUSameFlag(groupIndex, false);
        this.resetReverseLogisticsRateGroup(groupIndex);
      }

      if (this.isGroupReverseLogisticsExtraSku(groupIndex) && !this.hasOFASF) {
        this.setIsExtraSKUSameFlag(groupIndex, false);
        this.resetReverseLogisticsRateGroup(groupIndex);
      }

      if (this.getIsExtraSKUSameFlag(groupIndex)) {
        this.updateReverseLogisticsRateGroupBasedOnFulfillmentRate(groupIndex);
      }
    });

    this.pricelist.rateGroups.forEach((_, groupIndex) => {
      this.setStandardRateGroupLabel(groupIndex);
    });
  }

  public async onEditOrderFulfillments(
    event: { index: number, items: any[] }, 
    index: number
  ) {
    if (
      !event.items || 
      event.items.length === 0
    ) {
      this.filteredRates = [];
    }
  
    if (
      !this.previousParametersMap[index]
    ) {
      this.previousParametersMap[index] = {};
    }
  
    if (
      !this.previousRateTypesMap[index]
    ) {
      this.previousRateTypesMap[index] = {};
    }
  
    const existingRatesLength = this.pricelist
      .rateGroups[index]
      .rates.length;
    
    const isRemoval = event.items.length < existingRatesLength;
  
    if (
      isRemoval && 
      event.index < existingRatesLength
    ) {
      this.adjustMappingsAfterRemoval(
        index, 
        event.index
      );
    }
  
    this.pricelist
      .rateGroups[index]
      .rates = event.items;
    this.updateMappings(
      index, 
      event.items
    );
  
    const previousParameter = this.previousParametersMap[index][event.index];
    const previousRateType = this.previousRateTypesMap[index][event.index];
  
    const selectedRates = event.items[event.index];
    this.selectedCodes[index] = event.items.reduce(
      (acc, rate, idx) => {
        acc[idx] = rate.type;
        return acc;
      }, 
      {}
    );
  
    if (
      selectedRates
    ) {

      if (!this.rateTypeCodesMap[index]) {
        this.rateTypeCodesMap[index] = [];
      }

      if (
        selectedRates.type !== previousRateType && 
        previousRateType !== null && 
        previousRateType !== undefined
      ) {
        this.pricelist
          .rateGroups[index]
          .rates[event.index]
          .parameter = null;
        this.pricelist
          .rateGroups[index]
          .rates[event.index]
          .code = null; 
        this.rateTypeCodesMap[index][event.index] = [];
      }
  
      if (
        selectedRates.parameter !== previousParameter && 
        previousParameter !== null && 
        previousParameter !== undefined
      ) {
        this.pricelist
          .rateGroups[index]
          .rates[event.index]
          .code = null;
      }

      this.pricelist
        .rateGroups[index]
        .rates[event.index]
        .description = this.getRateDescription(
          selectedRates.type,
          selectedRates.parameter,
          selectedRates.perWeight,
          selectedRates.maxWeight
        );
  
      this.pricelist
        .rateGroups[index]
        .rates[event.index]
        .type = selectedRates.type;
  
      this.pricelist
        .rateGroups[index]
        .rates[event.index]
        .description = this.getRateDescription(
          selectedRates.type,
          selectedRates.parameter,
          selectedRates.perWeight,
          selectedRates.maxWeight
        );
  
      this.rateTypeParametersMap[index] = {
        ...this.rateTypeParametersMap[index],
        [event.index]: this.rateTypesMap[index]
          .filter(
            rateType => rateType.code === selectedRates.type
          )
          .reduce(
            (acc, rateType) => acc.concat(
              rateType.parameters.map(
                parameter => parameter.label
              )
            ), 
            []
          )
      };
  
      this.updateRateTypeCodesMap(
        index, 
        event, 
        selectedRates
      );

      this.pricelist
        .rateGroups[index]
        .rates[event.index]
        .description = this.getRateDescription(
          selectedRates.type,
          selectedRates.parameter,
          selectedRates.perWeight,
          selectedRates.maxWeight
        );
    }
  
    await this.setCategoryBasedOnRates(index);
    this.setStandardRateGroupLabel(index);
  
    this.updateExcludedAndSelectedCodes();

    this.hasOFPAP = this.isOFPAPSelected();
    this.hasOFASF = this.isOFASFSelected();

    if (this.isGroupReverseLogistics(index) && !this.hasOFPAP) {
      this.setIsExtraSKUSameFlag(index, false);
      this.resetReverseLogisticsRateGroup(index);
    }

    if (this.isGroupReverseLogisticsExtraSku(index) && !this.hasOFASF) {
      this.setIsExtraSKUSameFlag(index, false);
      this.resetReverseLogisticsRateGroup(index);
    }

    if (this.getIsExtraSKUSameFlag(index)) {
      this.updateReverseLogisticsRateGroupBasedOnFulfillmentRate(index);
    }
  
    if (
      selectedRates
    ) {
      this.previousParametersMap[index][event.index] = selectedRates.parameter;
      this.previousRateTypesMap[index][event.index] = selectedRates.type;
    }
  }

  private getWarehouseAddressLabel(warehouse: any): string {
    const address = warehouse?.address;

    if (!address) {
      return warehouse?.label || warehouse?.name || '';
    }

    if (typeof address === 'string') {
      return address;
    }

    return [
      address.county || address.city,
      address.countryCode || address.country
    ]
      .filter(Boolean)
      .join(', ');
  }
  
  private filterRateTypes(
    rateTypes, 
    selectedType, 
    filterField, 
    selectedLabel
  ): any[] {
    return rateTypes
      .filter(
        rateType => rateType.code === selectedType
      )
      .filter(
        rateType => rateType[filterField]
          .map(param => param.label)
          .includes(selectedLabel)
      );
  }
  
  private reduceRateTypes(
    filteredRateTypes,
    warehouseSelected,
    selectedLabels,
    codeField
  ): any[] {
    return filteredRateTypes.reduce(
      (acc, rateType) => {
        const codes = warehouseSelected
          ? rateType.codeDefault?.find(
              code => code.warehouse === warehouseSelected
            )?.code
          : rateType.legacyCode?.find(
              code => Object.keys(selectedLabels)
                .every(
                  key => code[key]?.label === selectedLabels[key]
                )
            )?.[codeField];

        return acc.concat(codes || []);
      },
      []
    );
  }

  private getAvailableWeightLabels(
    rateTypeCode: string | null | undefined,
    field: 'perWeight' | 'maxWeight'
  ): string[] {
    if (this.isRLFEW(rateTypeCode)) {
      return (
        field === 'maxWeight'
          ? [this.reverseLogisticsExtraWeightMaxWeightLabel]
          : [this.reverseLogisticsExtraWeightPerWeightLabel]
      );
    }

    return [];
  }

  private getAcceptableWeightLabels(
    rateTypeCode: string | null | undefined,
    selectedField: 'perWeight' | 'maxWeight',
    selectedLabel: string,
    checkField: 'perWeight' | 'maxWeight'
  ): string[] {
    if (this.isRLFEW(rateTypeCode)) {
      const matchesReverseLogisticsExtraWeightPair = (
        (
          selectedField === 'maxWeight' &&
          checkField === 'perWeight' &&
          selectedLabel === this.reverseLogisticsExtraWeightMaxWeightLabel
        ) ||
        (
          selectedField === 'perWeight' &&
          checkField === 'maxWeight' &&
          selectedLabel === this.reverseLogisticsExtraWeightPerWeightLabel
        )
      );

      if (!matchesReverseLogisticsExtraWeightPair) {
        return [];
      } 

      return (
        checkField === 'maxWeight'
          ? [this.reverseLogisticsExtraWeightMaxWeightLabel]
          : [this.reverseLogisticsExtraWeightPerWeightLabel]
      );
    }

    return [];
  }
  
  private updateRateTypeCodesMap(
    index,
    event,
    selectedRates
  ): void {
    if (selectedRates.type === 'RLROP') {
      this.rateTypeCodesMap[index] = {
        ...this.rateTypeCodesMap[index],
        [event.index]: []
      };

      this.pricelist.rateGroups[index].rates[event.index].code = null;
    }

    this.fieldsOrderFulfillment[3].disabled = [];
    this.fieldsOrderFulfillment[4].disabled = [];

    if (!this.rateTypeCodesMap[index]) {
      this.rateTypeCodesMap[index] = {};
    }

    const matchingRateType = this.rateTypesMap[index]
      .find(rateType => rateType.code === selectedRates.type);

    if (!matchingRateType) {
      this.rateTypeCodesMap[index][event.index] = [];
      this.pricelist.rateGroups[index].rates[event.index].code = null;
      return;
    }

    const availableMaxWeightLabels = this.getAvailableWeightLabels(
      selectedRates.type,
      'maxWeight'
    );

    const availablePerWeightLabels = this.getAvailableWeightLabels(
      selectedRates.type,
      'perWeight'
    );

    if (availableMaxWeightLabels.length) {
      this.fieldsOrderFulfillment[3].disabled = (
        matchingRateType.maxWeight?.map(maxWeight =>
          !availableMaxWeightLabels.includes(maxWeight.label)
        ) || []
      );
    }

    if (availablePerWeightLabels.length) {
      this.fieldsOrderFulfillment[4].disabled = (
        matchingRateType.perWeight?.map(perWeight =>
          !availablePerWeightLabels.includes(perWeight.label)
        ) || []
      );
    }

    if (selectedRates.parameter) {
      const filteredRateTypes = this.filterRateTypes(
        this.rateTypesMap[index],
        selectedRates.type,
        'parameters',
        selectedRates.parameter
      );

      const parameterCodes = this.reduceRateTypes(
        filteredRateTypes,
        this.warehouseSelected,
        { parameter: selectedRates.parameter },
        'overrideCodes'
      ) || [];

      this.rateTypeCodesMap[index] = {
        ...this.rateTypeCodesMap[index],
        [event.index]: parameterCodes
      };

      if (!this.hasAvailableCodes(parameterCodes)) {
        this.pricelist.rateGroups[index].rates[event.index].code = null;
      }
    }

    if (
      selectedRates.perWeight &&
      selectedRates.maxWeight
    ) {
      const filteredRateTypes = this.filterRateTypes(
        this.rateTypesMap[index],
        selectedRates.type,
        'perWeight',
        selectedRates.perWeight
      ).filter(
        rateType => rateType.maxWeight
          .map(param => param.label)
          .includes(selectedRates.maxWeight)
      );

      const weightCodes = this.reduceRateTypes(
        filteredRateTypes,
        this.warehouseSelected,
        {
          perWeight: selectedRates.perWeight,
          maxWeight: selectedRates.maxWeight
        },
        'overrideCodes'
      ) || [];

      this.rateTypeCodesMap[index] = {
        ...this.rateTypeCodesMap[index],
        [event.index]: weightCodes
      };

      if (!this.hasAvailableCodes(weightCodes)) {
        this.pricelist.rateGroups[index].rates[event.index].code = null;
      }
    }

    if (
      !selectedRates.parameter &&
      !(selectedRates.perWeight && selectedRates.maxWeight)
    ) {
      this.rateTypeCodesMap[index] = {
        ...this.rateTypeCodesMap[index],
        [event.index]: []
      };
      this.pricelist.rateGroups[index].rates[event.index].code = null;
    }

    if (selectedRates.maxWeight) {
      const acceptableLabels = this.getAcceptableWeightLabels(
        selectedRates.type,
        'maxWeight',
        selectedRates.maxWeight,
        'perWeight'
      );

      if (acceptableLabels.length) {
        this.fieldsOrderFulfillment[4].disabled = (
          matchingRateType.perWeight?.map(perWeight =>
            !acceptableLabels.includes(perWeight.label)
          ) || []
        );
      }
    }

    if (selectedRates.perWeight) {
      const acceptableLabels = this.getAcceptableWeightLabels(
        selectedRates.type,
        'perWeight',
        selectedRates.perWeight,
        'maxWeight'
      );

      if (acceptableLabels.length) {
        this.fieldsOrderFulfillment[3].disabled = (
          matchingRateType.maxWeight?.map(maxWeight =>
            !acceptableLabels.includes(maxWeight.label)
          ) || []
        );
      }
    }
  }
  
  private adjustMappingsAfterRemoval(index: number, removedIndex: number) {
    const previousParams = this.previousParametersMap[index];
    const previousRates = this.previousRateTypesMap[index];
  
    for (let i = removedIndex + 1; i < Object.keys(previousParams).length; i++) {
      previousParams[i - 1] = previousParams[i];
      previousRates[i - 1] = previousRates[i];
    }
  
    delete previousParams[Object.keys(previousParams).length - 1];
    delete previousRates[Object.keys(previousRates).length - 1];
  }


  private updateMappings(
    index: number, 
    items: any[] | null | undefined
  ) {
    if (!items || items.length === 0) {
      this.selectedCodes[index] = {};
      this.rateTypeParametersMap[index] = {};
      this.rateTypeCodesMap[index] = {};
      return;
    }

    this.selectedCodes[index] = items
      .reduce(
        (acc, rate, idx) => {
          acc[idx] = rate?.type || null;
          return acc;
        }, 
        {}
      );
  
    this.rateTypeParametersMap[index] = items
      .reduce(
        (acc, rate, idx) => {
          acc[idx] = (this.rateTypesMap[index] || [])
            .filter(
              rateType => rateType.code === rate?.type
            )
            .reduce(
              (innerAcc, rateType) => innerAcc.concat(
                rateType.parameters?.map(
                  parameter => parameter.label
                ) || []
              ), 
              []
            );
          return acc;
        }, 
        {}
      );
  }

  
  public get excludedCodesList(): string[] {
    return this.excludedCodes;
  }

  public handleIsExtraSKUSameChange(
    isExtraSKUSame: boolean,
    index: number 
  ): void {
    if (
      isExtraSKUSame &&
      this.shouldDisableSameCalculation(index)
    ) {
      this.setIsExtraSKUSameFlag(index, false);
      return;
    }

    this.setIsExtraSKUSameFlag(
      index,
      isExtraSKUSame
    );

    if (isExtraSKUSame) {
      this.updateReverseLogisticsRateGroupBasedOnFulfillmentRate(
        index
      );
    } else {
      this.resetReverseLogisticsRateGroup(
        index
      );
    }
  }

  private resetReverseLogisticsRateGroup(index: number): void {
    const rateGroup = this.pricelist?.rateGroups?.[index];
    if (!rateGroup?.rates) {
      return;
    }

    rateGroup.rates.forEach((rate, rateIndex) => {
      const rateTypeString = String(rate.type);

      if (!this.isReverseLogisticsExtraSkuRate(rateTypeString)) {
        return;
      }

      rate.parameter = null;
      rate.code = null;
      rate.fee = null;

      if (!this.previousParametersMap[index]) {
        this.previousParametersMap[index] = [];
      }
      if (!this.previousRateTypesMap[index]) {
        this.previousRateTypesMap[index] = [];
      }

      this.previousParametersMap[index][rateIndex] = null;
      this.previousRateTypesMap[index][rateIndex] = null;
    });
  }

  private updateReverseLogisticsRateGroupBasedOnFulfillmentRate(index: number): void {
    const rateGroup = this.pricelist?.rateGroups?.[index];
    if (!rateGroup?.rates) {
      return;
    }

    let ofpapRate: RateWms | null = null;
    let ofasfRate: RateWms | null = null;

    this.pricelist.rateGroups.forEach(group => {
      group.rates.forEach(rate => {
        const rateTypeString = String(rate.type);

        if (rateTypeString === 'OFPAP') {
          ofpapRate = rate;
        }

        if (rateTypeString === 'OFASF') {
          ofasfRate = rate;
        }
      });
    });

    rateGroup.rates.forEach((rate, rateIndex) => {
      const rateTypeString = String(rate.type);

      let sourceRate: RateWms | null = null;

      if (this.isRLROP(rateTypeString)) {
        sourceRate = ofpapRate;
      }

      if (this.isRLOFA(rateTypeString)) {
        sourceRate = ofasfRate;
      }

      if (!sourceRate) {
        return;
      }

      rate.parameter = sourceRate.parameter;
      rate.fee = sourceRate.fee;

      if (!this.previousParametersMap[index]) {
        this.previousParametersMap[index] = [];
      }

      if (
        this.previousParametersMap[index][rateIndex] !== undefined &&
        this.previousParametersMap[index][rateIndex] !== null &&
        this.previousParametersMap[index][rateIndex] !== String(rate.parameter)
      ) {
        rate.code = null;
      }

      this.previousParametersMap[index][rateIndex] = String(rate.parameter);

      const filteredRateTypes = this.rateTypesMap[index]
        .filter(rateType => rateType.code === rateTypeString)
        .filter(rateType =>
          rateType.parameters
            .map(param => param.label)
            .includes(String(rate.parameter))
        );

      this.rateTypeCodesMap[index] = {
        ...this.rateTypeCodesMap[index],
        [rateIndex]: filteredRateTypes.reduce((acc, rateType) => {
          const codes = this.warehouseSelected
            ? rateType.codeDefault.find(
                code => code.warehouse === this.warehouseSelected
              )?.code
            : rateType.legacyCode.find(
                code => code.parameter.label === String(rate.parameter)
              )?.overrideCodes;

          return acc.concat(codes || []);
        }, [])
      };
    });
  }
  
  private resetReverseLogisticsExtraSkuRates(): void {
    this.pricelist.rateGroups.forEach((rateGroup, groupIndex) => {
      rateGroup.rates.forEach((rate, rateIndex) => {
        const rateTypeString = String(rate.type);

        if (this.isReverseLogisticsExtraSkuRate(rateTypeString)) {
          rate.parameter = null;
          rate.code = null;
          rate.fee = null;

          if (!this.previousParametersMap[groupIndex]) {
            this.previousParametersMap[groupIndex] = [];
          }
          if (!this.previousRateTypesMap[groupIndex]) {
            this.previousRateTypesMap[groupIndex] = [];
          }

          this.previousParametersMap[groupIndex][rateIndex] = null;
          this.previousRateTypesMap[groupIndex][rateIndex] = null;

          this.rateTypeParametersMap[groupIndex] = {
            ...this.rateTypeParametersMap[groupIndex],
            [rateIndex]: this.rateTypesMap[groupIndex]
              .filter(rateType => rateType.code === rateTypeString)
              .reduce(
                (acc, rateType) => acc.concat(
                  rateType.parameters.map(parameter => parameter.label)
                ),
                []
              )
          };

          const filteredRateTypes = this.rateTypesMap[groupIndex]
            .filter(rateType => rateType.code === rateTypeString)
            .filter(rateType =>
              rateType.parameters
                .map(param => param.label)
                .includes(String(rate.parameter))
            );

          this.rateTypeCodesMap[groupIndex] = {
            ...this.rateTypeCodesMap[groupIndex],
            [rateIndex]: filteredRateTypes.reduce((acc, rateType) => {
              const codes = this.warehouseSelected
                ? rateType.codeDefault.find(
                    code => code.warehouse === this.warehouseSelected
                  )?.code
                : rateType.legacyCode.find(
                    code => code.parameter.label === String(rate.parameter)
                  )?.overrideCodes;
              return acc.concat(codes || []);
            }, [])
          };

          if (this.selectedCodes[groupIndex]) {
            delete this.selectedCodes[groupIndex][rateIndex];
          }
        }
      });
    });

    this.wasExtraSKUSameFlag = false;
    this.updateExcludedAndSelectedCodes();
  }

  
  private updateReverseLogisticsRatesBasedOnFulfillmentRates(): void {
    let ofpapRate: RateWms | null = null;
    let ofasfRate: RateWms | null = null;

    this.wasExtraSKUSameFlag = this.isExtraSKUSameFlag;

    this.pricelist.rateGroups.forEach((rateGroup) => {
      rateGroup.rates.forEach((rate) => {
        const rateTypeString = String(rate.type);

        if (rateTypeString === 'OFPAP') {
          ofpapRate = rate;
        }

        if (rateTypeString === 'OFASF') {
          ofasfRate = rate;
        }
      });
    });

    this.pricelist.rateGroups.forEach((rateGroup, groupIndex) => {
      rateGroup.rates.forEach((rate, rateIndex) => {
        const rateTypeString = String(rate.type);

        let sourceRate: RateWms | null = null;

        if (this.isRLROP(rateTypeString)) {
          sourceRate = ofpapRate;
        }

        if (this.isRLOFA(rateTypeString)) {
          sourceRate = ofasfRate;
        }

        if (!sourceRate) {
          return;
        }

        rate.parameter = sourceRate.parameter;
        rate.fee = sourceRate.fee;

        if (
          this.previousParametersMap[groupIndex] &&
          this.previousParametersMap[groupIndex][rateIndex] !== undefined &&
          this.previousParametersMap[groupIndex][rateIndex] !== null &&
          this.previousParametersMap[groupIndex][rateIndex] !== String(rate.parameter)
        ) {
          rate.code = null;
        }

        if (!this.previousParametersMap[groupIndex]) {
          this.previousParametersMap[groupIndex] = [];
        }

        this.previousParametersMap[groupIndex][rateIndex] = String(rate.parameter);

        const filteredRateTypes = this.rateTypesMap[groupIndex]
          .filter(rateType => rateType.code === rateTypeString)
          .filter(rateType =>
            rateType.parameters
              .map(param => param.label)
              .includes(String(rate.parameter))
          );

        this.rateTypeCodesMap[groupIndex] = {
          ...this.rateTypeCodesMap[groupIndex],
          [rateIndex]: filteredRateTypes.reduce((acc, rateType) => {
            const codes = this.warehouseSelected
              ? rateType.codeDefault.find(
                  code => code.warehouse === this.warehouseSelected
                )?.code
              : rateType.legacyCode.find(
                  code => code.parameter.label === String(rate.parameter)
                )?.overrideCodes;

            return acc.concat(codes || []);
          }, [])
        };
      });
    });
  }
  
  private updateExcludedAndSelectedCodes() {
    this.excludedCodes = this.getUsedRateTypeCodes();
    this.filteredRates = (this.allRates || []).filter(
      rate => !this.excludedCodes.includes(rate.code)
    );
  }

  public get filteredRatesGetter(): RateTypeWms[] {
    return this.filteredRates;
  }


  public async setCategoryBasedOnRates(index: number): Promise<void> {
    this.categoryMap[index] = null;
    this.previousCategoryMap[index] = null;
    this.rateTypesMap[index] = await this.setRateTypes();
  }
  

  public async setRateTypes() {
    if (!this.allRates.length) {
      this.allRates = await this.rateTypeService.getAll();
  
      console.log('RATE TYPES FROM BACKEND:', this.allRates);
    }
  
    return this.getFilteredWmsRateTypes();
  }
  
  async onLabelChange(label: string, index: any) {
    this.pricelist
      .rateGroups[index]
      .label = label;
  }

  public isOFPAPSelected(): boolean {
    if (!this.selectedCodes) {
      return false;
    }

    for (const groupIndex in this.selectedCodes) {
      for (const code of Object.values(this.selectedCodes[groupIndex])) {
        if (code === 'OFPAP') {
          return true;
        }
      }
    }

    return false;
  }

  public isOFASFSelected(): boolean {
    if (!this.selectedCodes) {
      return false;
    }

    for (const groupIndex in this.selectedCodes) {
      for (const code of Object.values(this.selectedCodes[groupIndex])) {
        if (code === 'OFASF') {
          return true;
        }
      }
    }

    return false;
  }

  public async onSave() {
    if (
      !(
        this.pricelistIsClone ||
        this.pricelistIsEdit ||
        this.pricelistIsMarkup ||
        this.pricelistIsNew
      )
    ) {
      return false;
    }

    const pricelistObj = {
      ...this.pricelist
    };


    const allRateTypes = await this.rateTypeService.getAll();
    if (
      Array.isArray(pricelistObj.rateGroups)
    ) {
      pricelistObj.hasSameExtraSKU = pricelistObj.rateGroups?.some(
        (rateGroup: any) => !!rateGroup.isExtraSKUSameFlag
      );
      pricelistObj.rateGroups = pricelistObj.rateGroups.map(
        (rateGroup: any) => {
          return {
            label: rateGroup.label,
            categoryKey: rateGroup.categoryKey,
            isExtraSKUSameFlag: rateGroup.isExtraSKUSameFlag,
            rates: rateGroup.rates.map(
              (rate: any) => {
                const matchedRateType = allRateTypes.find(
                  rateType => rateType.code === rate.type
                );
                const matchedParameter = matchedRateType?.parameters?.find(
                  parameter => parameter.label === rate.parameter
                ) as unknown as { _id: string };

                const matchedMaxWeight = matchedRateType?.maxWeight?.find(
                  parameter => parameter.label === rate.maxWeight
                ) as unknown as { _id: string };

                const matchedPerWeight = matchedRateType?.perWeight?.find(
                  parameter => parameter.label === rate.perWeight
                ) as unknown as { _id: string };
                return {
                  type: matchedRateType?._id,
                  parameter: matchedParameter?._id,
                  maxItems: rate.maxItems,
                  maxWeight: matchedMaxWeight?._id,
                  perWeight: matchedPerWeight?._id,
                  code: rate.code,
                  fee: {
                    value: rate.fee
                  },
                };
              }
            ),
          };
        }
      );
    }
  
    const context = (
      this.pricelist
          .context
    );

    if (
      this
        .warehouseSelected
    ) {
      pricelistObj
        .warehouse = (
          await (
            this.pricelistWmsService
                .getWarehouseByCodePartner(
                  this
                    .warehouseSelected
                )
          )
        )._id;
        pricelistObj
        .countryCode = (
          await (
            this.pricelistWmsService
                .getWarehouseByCodePartner(
                  this
                    .warehouseSelected
                )
          )
        ).countryCode;
    }

    this.pricelist = undefined;

    if (
      Array
        .isArray(
          pricelistObj
            .rateGroups
        )
    ) {
      pricelistObj
        .rateGroups = (
          (
            <RateGroupWms[]>(
              pricelistObj
                .rateGroups
              )
          )
        ); // Remove reassignment when proper validation with error messages is implemented
    }

    if (
      Array
        .isArray(
          pricelistObj
            .services
      )
    ) {
      pricelistObj
        .services = (
          (
            <Service[]>(
              pricelistObj
                .services
              )
          )
          .map(
            pricelistService => (
              pricelistService
                ._id
            )
          )
        )
    };

    if (
      Array
        .isArray(
          pricelistObj
            .users
      )
    ) {
      pricelistObj
        .users = (
          (
            <User[]>(
              pricelistObj
                .users
              )
          )
          .map(
            pricelistUser => (
              pricelistUser
                ._id
            )
          )
        )
    };

    if (this.pricelistIsMarkup) {
      this.pricelistDomain = undefined;
    }

    await (
      this.pricelistWmsService
          .upsert(
            [
              pricelistObj
            ],
            this.pricelistDomain
          )
    );

    this.goBack(
      context
    );
  }

  public onEditInfo(
    key: string,
    data: {
      value: string;
      languageCode: string;
    }
  ) {
    let {
      value,
      languageCode
    } = data;

    value = (
      (
        isStringSafeNotEmpty(
          value
        )
      ) ?
        value :
        ''
    );

    if (
      [
        'terms'
      ].includes(
        key
      )
    ) {
      if (
        !languageCode ||
        (
          languageCode ===
          DEFAULT_LANGUAGE_CODE
        )
      ) {
        this.pricelist[
          key
        ] = value;
      }
      else {
        if (
          Array
            .isArray(
              this.pricelist
                  .translations
            )
        ) {
          const index = (
            this.pricelist
                .translations
                .findIndex(
                  translation => (
                    (
                      (
                        translation
                          .key
                      ) ===
                      key
                    ) &&
                    (
                      (
                        translation
                          .languageCode
                      ) ===
                      languageCode
                    )
                  )
                )
          );

          if (
            index >
            -1
          ) {
            this.pricelist
                .translations[
                  index
                ]
                .value = (
                  value
                );
          }
          else {
            this.pricelist
                .translations
                .push({
                  key,
                  languageCode,
                  value
                });
          }
        }
        else {
          this.pricelist
              .translations = [{
                key,
                languageCode,
                value
              }];
        }
      }
    }
  }

  public onLanguageCodeActiveLabel(
    languageCode: string
  ) {
    this.languageCodeActiveLabel = (
      languageCode
    );

    if (
      this.languageCodeActiveLabel &&
      (
        this.languageCodeActiveLabel !==
        DEFAULT_LANGUAGE_CODE
      )
    ) {
      const translation = (
        (
          Array
            .isArray(
              this.pricelist
                  .translations
            )
        ) ?
          (
            this.pricelist
                .translations
                .find(
                  translation => (
                    (
                      (
                        translation
                          .key
                      ) ===
                      'label'
                    ) &&
                    (
                      (
                        translation
                          .languageCode
                      ) ===
                      this.languageCodeActiveLabel
                    )
                  )
                )
          ) :
          null
      );

      if (
        !(
          translation &&
          (
            isStringSafeNotEmpty(
              translation
                .value
            )
          )
        )
      ) {
        this.onPricelistLabel(
          this.pricelist
              .label
        );
      }
    }
  }

  public onPricelistLabel(
    value: string
  ) {
    value = (
      (
        isStringSafeNotEmpty(
          value
        )
      ) ?
        value :
        ''
    );

    if (
      !this.languageCodeActiveLabel ||
      (
        this.languageCodeActiveLabel ===
        DEFAULT_LANGUAGE_CODE
      )
    ) {
      this.pricelist
          .label = (
            value
          );
    }
    else {
      if (
        Array
          .isArray(
            this.pricelist
                .translations
          )
      ) {
        const index = (
          this.pricelist
              .translations
              .findIndex(
                translation => (
                  (
                    (
                      translation
                        .key
                    ) ===
                    'label'
                  ) &&
                  (
                    (
                      translation
                        .languageCode
                    ) ===
                    this.languageCodeActiveLabel
                  )
                )
              )
        );

        if (
          index >
          -1
        ) {
          this.pricelist
              .translations[
                index
              ]
              .value = (
                value
              );
        }
        else {
          this.pricelist
              .translations
              .push({
                key: 'label',
                languageCode: (
                  this.languageCodeActiveLabel
                ),
                value
              });
        }
      }
      else {
        this.pricelist
            .translations = [{
              key: 'label',
              languageCode: (
                this.languageCodeActiveLabel
              ),
              value
            }];
      }
    }
  }

  public onPricelistServicesActive(
    services: Service[]
  ) {
    if (
      !this.pricelist ||
      this.pricelistIsReadOnly
    ) {
      return false;
    }

    this.pricelist
        .services = (
          naturalSort(
            services,
            'codeLegacy'
          )
        );
  }

  public onPricelistUsersActive(
    users: User[]
  ) {
    if (
      !this.pricelist ||
      this.pricelistIsReadOnly
    ) {
      return false;
    }

    this.pricelist
        .users = (
          naturalSort(
            users,
            'code'
          )
        );
  }

  private goBack(
    context?: string
  ) {

    if (
      !context &&
      this.pricelist
    ) {
      context = (
        this.pricelist
            .context
      );
    }

    if (!context) {
      return (
        this.router
            .navigate(
              [
                (
                  this.pricelistDomainIsCosts ?
                    `/wms/cost-lists/context/active` :
                    `/wms/context/active`
                )
              ],
              {
                queryParamsHandling: (
                  'preserve'
                )
              }
            )
      );
    }

    this.router
        .navigate(
          [
            (
              this.pricelistDomainIsCosts ?
                `/wms/cost-lists/context/${(
                  (
                    getContextPath(
                      context
                    )
                  )
                )}` :
                `/wms/context/${(
                  (
                    getContextPath(
                      context
                    )
                  )
                )}`
            )
          ],
          {
            queryParamsHandling: (
              'preserve'
            )
          }
        );
  }

  private setAuthEmail() {
    this.authEmail = (
      this.msalService
          .getAccount()
          .userName
    );
  }

  private async setUsers() {
    this.users = (
      await (
        this.authService
            .getAll()
      )
    );
  }

  private getCurrencyOption(code): Currency {
    return (
      getModelOption(
        this.currencyOptions,
        code
      )
    );
  }

  public async setPartnerCodeActive(partnerCode: string): Promise<void> {
    this.pricelist.partnerCode = partnerCode;

    if (!this.pricelistDomainIsCosts) {
      await this.setDefaultBizPayTerms();
    }

    if (this.pricelist.rateGroups && Array.isArray(this.pricelist.rateGroups)) {
      for (let index = 0; index < this.pricelist.rateGroups.length; index++) {
        const rategroup = this.pricelist.rateGroups[index];

        if (rategroup.rates && Array.isArray(rategroup.rates)) {
          for (let rateIndex = 0; rateIndex < rategroup.rates.length; rateIndex++) {
            const selectedRate = rategroup.rates[rateIndex];
            const event = { index: rateIndex };
            selectedRate.code = null;
            this.updateRateTypeCodesMap(index, event, selectedRate);
          }
        }
      }
    }
  }
  

  public setCurrencyOptionActive(code) {
    this.currencyOptionActive = (
      this.getCurrencyOption(
        code
      )
    );

    this.pricelist
        .currencyCode = (
          code
        );

    this.pricelist
        .currencySymbol = (
          this.currencyOptionActive
              .symbol
        );

    this.setFeeLabelCurrency();
    this.setRateCurrency();
  }

  public setValidTimestampStart(
    value: string
  ) {
    this.setValidTimestampRaw(
      'validTimestampStart',
      value
    );
  }

  public setValidTimestampEnd(
    value: string
  ) {
    this.setValidTimestampRaw(
      'validTimestampEnd',
      value,
      true
    );
  }

  private async setPartnerCodes() {
     const warehouses = (
      await 
        this.pricelistWmsService
            .getWarehousesCodes()
    );

    this.partnerCodes = warehouses
      .filter(warehouse => warehouse.codePartnerCountry)
      .map(warehouse => warehouse.codePartnerCountry);
  }

  private async setServices() {
    this.services = (
      await (
        this.serviceService
            .getAll(true)
      )
    );
  }

  private setFeeLabelCurrency() {
    /* this.setFeeLabelCurrencyRatesClone(
      'fieldsRates'
    ); */
  }

  private setFeeLabelCurrencyRatesClone(member) {
    const fieldsRates = [
      ...this[
        member
      ]
    ];

    this.setFeeLabelCurrencyRatesMutate(
      fieldsRates
    );

    this[
      member
    ] = (
      fieldsRates
    );
  }

  private getRateDescription(
    rateTypeCode: string | null | undefined,
    parameter?: string | null,
    perWeight?: string | null,
    maxWeight?: string | null
  ): string {
    if (!rateTypeCode) {
      return '';
    }
  
    const rateType = (this.allRates || []).find(
      item => item.code === rateTypeCode
    );
  
    if (!rateType) {
      return '';
    }
  
    const normalize = (value: any): string => {
      return String(value || '').trim().toLowerCase();
    };
  
    const parameterNorm = normalize(parameter);
    const perWeightNorm = normalize(perWeight);
    const maxWeightNorm = normalize(maxWeight);
  
    const overrides = Array.isArray(rateType.descriptionOverrides)
      ? rateType.descriptionOverrides
      : [];
  
    if (parameterNorm) {
      const parameterOverride = overrides.find(item =>
        normalize(item?.parameter?.label) === parameterNorm
      );
  
      if (parameterOverride?.description) {
        return parameterOverride.description;
      }
    }
  
    if (perWeightNorm && maxWeightNorm) {
      const weightOverride = overrides.find(item =>
        normalize(item?.perWeight?.label) === perWeightNorm &&
        normalize(item?.maxWeight?.label) === maxWeightNorm
      );
  
      if (weightOverride?.description) {
        return weightOverride.description;
      }
    }
  
    return rateType.description || '';
  }

  private getWeightOptionDisabled(
    rate: RateWms,
    rateTypes: RateTypeWms[],
    field: 'perWeight' | 'maxWeight'
  ): boolean | boolean[] {
    const selectedType = this.getRateTypeCode(rate);
    const matchingRateType = rateTypes.find(
      rateType => rateType.code === selectedType
    );
    const options = matchingRateType?.[field] || [];

    if (!options.length) {
      return true;
    }

    let availableLabels = this.getAvailableWeightLabels(
      selectedType,
      field
    );

    if (field === 'maxWeight' && rate.perWeight) {
      availableLabels = this.getAcceptableWeightLabels(
        selectedType,
        'perWeight',
        String(rate.perWeight),
        'maxWeight'
      );
    }

    if (field === 'perWeight' && rate.maxWeight) {
      availableLabels = this.getAcceptableWeightLabels(
        selectedType,
        'maxWeight',
        String(rate.maxWeight),
        'perWeight'
      );
    }

    if (!availableLabels.length) {
      return false;
    }

    return options.map(option =>
      !availableLabels.includes(option.label)
    );
  }

  public getFieldsFulfillment(index: number): Field[] {
    if (!this.pricelist) {
      return [];
    }

    const rateTypes = this.rateTypesMap[index] || this.getFilteredWmsRateTypes();
    
    return [
      {
        ...this.fieldsOrderFulfillment[0],
        values: rateTypes.map(rateType => rateType.code),
        valueLabels: rateTypes.map(rateType => rateType.name),
        disabled: this.getRateTypeOptionDisabledMatrix(index, rateTypes)
      },
      {
        ...this.fieldsOrderFulfillment[1],
        values: Object.values(this.rateTypeParametersMap[index] || {}),
        valueLabels: Object.values(this.rateTypeParametersMap[index] || {})
      },
      this.fieldsOrderFulfillment[2],
      {
        ...this.fieldsOrderFulfillment[3],
        values: (this.pricelist.rateGroups[index]?.rates || []).map((rate, rowIndex) => {
          const selectedType = this.getRateTypeCode(rate);
          const matchingRateType = rateTypes.find(rateType => rateType.code === selectedType);

          if (!matchingRateType?.maxWeight) {
            return [];
          }

          return matchingRateType.maxWeight.map(weight => weight.label);
        }),
        valueLabels: (this.pricelist.rateGroups[index]?.rates || []).map((rate, rowIndex) => {
          const selectedType = this.getRateTypeCode(rate);
          const matchingRateType = rateTypes.find(rateType => rateType.code === selectedType);

          if (!matchingRateType?.maxWeight) {
            return [];
          }

          return matchingRateType.maxWeight.map(weight => weight.label);
        }),
        disabled: (this.pricelist.rateGroups[index]?.rates || []).map(rate =>
          this.getWeightOptionDisabled(
            rate,
            rateTypes,
            'maxWeight'
          )
        )
      },
      {
        ...this.fieldsOrderFulfillment[4],
        values: (this.pricelist.rateGroups[index]?.rates || []).map((rate, rowIndex) => {
          const selectedType = this.getRateTypeCode(rate);
          const matchingRateType = rateTypes.find(rateType => rateType.code === selectedType);

          if (!matchingRateType?.perWeight) {
            return [];
          }

          return matchingRateType.perWeight.map(weight => weight.label);
        }),
        valueLabels: (this.pricelist.rateGroups[index]?.rates || []).map((rate, rowIndex) => {
          const selectedType = this.getRateTypeCode(rate);
          const matchingRateType = rateTypes.find(rateType => rateType.code === selectedType);

          if (!matchingRateType?.perWeight) {
            return [];
          }

          return matchingRateType.perWeight.map(weight => weight.label);
        }),
        disabled: (this.pricelist.rateGroups[index]?.rates || []).map(rate =>
          this.getWeightOptionDisabled(
            rate,
            rateTypes,
            'perWeight'
          )
        )
      },
      {
        ...this.fieldsOrderFulfillment[5],
        values: (this.pricelist.rateGroups[index]?.rates || []).map(
          (_, rowIndex) => this.rateTypeCodesMap[index]?.[rowIndex] || []
        ),
        valueLabels: (this.pricelist.rateGroups[index]?.rates || []).map(
          (_, rowIndex) => this.rateTypeCodesMap[index]?.[rowIndex] || []
        ),
        disabled: (this.pricelist.rateGroups[index]?.rates || []).map(
          (_, rowIndex) => !this.hasAvailableCodes(this.rateTypeCodesMap[index]?.[rowIndex] || [])
        )
      },
      this.fieldsOrderFulfillment[6],
      {
        ...this.fieldsOrderFulfillment[7],
        disabled: Array(this.fieldsOrderFulfillment[7].values?.length || 1).fill(true)
      }
    ];
  }

  public get warehouseSelected(): string | undefined {
    if (this.pricelist.partnerCode) {
      return WAREHOUSE_PARTNER_CODE_MAP[
        this.pricelist.partnerCode
          .substring(0, 2)
          .toUpperCase()
      ];
    }
    return undefined; 
  }

  private setFeeLabelCurrencyRatesMutate(fieldsRates) {
    fieldsRates
      .forEach(
        (
          rate,
          index
        ) => {
          if (
            rate
              .label
              .includes(
                'Fee'
              )
          ) {
            fieldsRates[
              index
            ].label = `${(
                rate
                  .label
                  .split(
                    ' ('
                  )[0]
              )} (${
                this.pricelist
                    .currencySymbol
              })`;
          }
        }
      );
  }

  private transformRates(
    pricelists
  ): void {
    pricelists.forEach(
      pricelist => {
        pricelist.rateGroups = (
          Array.isArray(
            pricelist.rateGroups
          ) ?
            pricelist.rateGroups :
            []
        );

        pricelist.rateGroups.forEach(
          rateGroup => {
            this.labelService.generateUniqueLabel(rateGroup.label);
            rateGroup.rates = (
              Array.isArray(
                rateGroup.rates
              ) ?
                rateGroup.rates :
                []
            ).map(
              rate => {
                const rateTypeCode = this.getRateTypeCode(
                  rate
                );

                const parameterLabel = this.getRateTypeParameterLabel(
                  rateTypeCode,
                  'parameters',
                  rate.parameter
                );

                const maxWeightLabel = this.getRateTypeParameterLabel(
                  rateTypeCode,
                  'maxWeight',
                  rate.maxWeight
                );

                const perWeightLabel = this.getRateTypeParameterLabel(
                  rateTypeCode,
                  'perWeight',
                  rate.perWeight
                );

                return {
                  type: rateTypeCode,
                  parameter: parameterLabel,
                  maxItems: rate.maxItems,
                  maxWeight: maxWeightLabel,
                  perWeight: perWeightLabel,
                  code: rate.code,
                  fee: this.getRateFeeValue(
                    rate
                  ),
                  description: this.getRateDescription(
                    rateTypeCode,
                    parameterLabel,
                    perWeightLabel,
                    maxWeightLabel
                  )
                };
              }
            );
          }
        );
        pricelist.rateGroups.forEach((rateGroup: any) => {
        if (typeof rateGroup.isExtraSKUSameFlag !== 'boolean') {
          rateGroup.isExtraSKUSameFlag = false;
        }
      });
      }
    );

    this.hasSameExtraSKU = this.hasReverseLogisticsExtraSkuRate();
    this.updateMappingsAfterTransformation();
  }
  
  private fillSelectedCodes(): void {
    this.pricelist.rateGroups.forEach(
      (rateGroup, groupIndex) => {
        this.selectedCodes[groupIndex] = rateGroup.rates.reduce(
          (acc, rate, rateIndex) => {
            acc[rateIndex] = rate.type;
            return acc;
          }, 
          {}
        );
      }
    );
  }
  
  private async updateMappingsAfterTransformation(): Promise<void> {
    await this.initializeRateTypesMap();
  
    this.fillSelectedCodes();
  
    for (
      const index in this.pricelist.rateGroups
    ) {
      const numericIndex = Number(index);
  
      await this.setCategoryBasedOnRates(
        numericIndex
      );

      this.setStandardRateGroupLabel(
        numericIndex
      );

      const rateGroup = this.pricelist.rateGroups[numericIndex];
  
      this.updateMappings(
        numericIndex, 
        this.pricelist.rateGroups[numericIndex].rates
      );

      if (!this.previousParametersMap[numericIndex]) {
        this.previousParametersMap[numericIndex] = {};
    }
    if (!this.previousRateTypesMap[numericIndex]) {
        this.previousRateTypesMap[numericIndex] = {};
    }

      rateGroup.rates.forEach((selectedRates, eventIndex) => {
        this.previousParametersMap[numericIndex][eventIndex] = String(selectedRates.parameter);
        this.previousRateTypesMap[numericIndex][eventIndex] = String(selectedRates.type);

        const event = {
          index: eventIndex,
          items: rateGroup.rates,
        };

        this.updateRateTypeCodesMap(numericIndex, event, selectedRates);
      });
      this.hasOFPAP = this.isOFPAPSelected();
      this.hasOFASF = this.isOFASFSelected();

      if (this.isGroupReverseLogistics(numericIndex) && !this.hasOFPAP) {
        this.setIsExtraSKUSameFlag(numericIndex, false);
        this.resetReverseLogisticsRateGroup(numericIndex);
      }

      if (this.isGroupReverseLogisticsExtraSku(numericIndex) && !this.hasOFASF) {
        this.setIsExtraSKUSameFlag(numericIndex, false);
        this.resetReverseLogisticsRateGroup(numericIndex);
      }

      if (this.getIsExtraSKUSameFlag(numericIndex)) {
        this.updateReverseLogisticsRateGroupBasedOnFulfillmentRate(numericIndex);
      }
    }
  
    this.updateExcludedAndSelectedCodes();
  }
  

  private async setPricelist() {
    const params = (
      await 
        this.route
            .params
            .pipe(
              first()
            )
            .toPromise()
    );
    
    this.pricelistIsNew = (
      !params
        ._id
    );
    
    if (this.pricelistIsNew) {
      this.pricelist = new PricelistWms(
        DEFAULT_CURRENCY_CODE,
        getCurrencySymbol(
          DEFAULT_CURRENCY_CODE
        ),
        this.authEmail,
        (
          this.services
              .filter(
                service => (
                  (
                    PRICELIST_SERVICE_CODES_LEGACY_DEFAULT
                      .includes(
                        service
                          .codeLegacy
                      )
                  )
                )
              )
        )
      );

      return;
    }

    this.pricelist = (
      await
        this.pricelistWmsService
            .get(
              params._id,
              this.pricelistDomain
            )
    );
  }

  private setPricelistDomain() {
    this.pricelistDomain = (
      (
        this.router
            .url
            .startsWith(
              '/wms/cost-lists'
            )
      ) ?
        'costs' :
        null
    );
  }

  private setSidebarActiveState() {
    this.sidebarService
        .setActiveState({
          context: (
            this.getSidebarContext()
          ),
          isCostLists: (
            this.pricelistDomainIsCosts
          ),
          isWms: true
        });
  }

  private getSidebarContext(): 'active' | 'archived' | 'removed' {
    const context = (
      getContextPath(
        this.pricelist ?
          this.pricelist
              .context :
          null
      )
    );

    return (
      (
        [
          'archived',
          'removed'
        ].includes(
          context
        )
      ) ?
        (
          context as 'archived' | 'removed'
        ) :
        'active'
    );
  }

  private async setPricelistIsClone() {
    const urlSegments =(
      await 
        this.route
            .url
            .pipe(
              first()
            )
            .toPromise()
    );

    this.pricelistIsClone = (
      (
        (
          urlSegments
            .length
        ) >
        3
      ) &&
      (
        (
          urlSegments[3]
            .path
        ).startsWith(
          'clone'
        )
      )
    );

    if (
      this.pricelist &&
      this.pricelistIsClone
    ) {
      this.showRefreshWarning = true;
      
      this.setPricelistDiscount();
      
      this.pricelist
          .isDraft = (
            true
          );

      this.pricelist
          .label = `${(
            this.pricelist
                .label
          )} (Clone)`;

      this.pricelist
          .ownerEmail = (
            this.authEmail
          );

      delete (
        this.pricelist
            ._id
      );

      delete (
        this.pricelist
            .currencySymbol
      );

      delete (
        this.pricelist
            .labelHuman
      );
    }
  }

  private async setPricelistIsMarkup() {
    const urlSegments =(
      await 
        this.route
            .url
            .pipe(
              first()
            )
            .toPromise()
    );
    this.pricelistIsMarkup = (
      (
        (
          urlSegments
            .length
        ) >
        3
      ) &&
      (
        (
          urlSegments[3]
            .path
        ) ===
        'markup'
      )
    );

    if (
      this.pricelist &&
      this.pricelistIsMarkup
    ) {
      this.showRefreshWarning = true;
      
      this.setPricelistIncrease();
      
      this.pricelist
          .isDraft = (
            true
          );

      this.pricelist
          .label = `${(
            this.pricelist
                .label
          )} - ${(
            PRICELIST_OFFICIAL_DEFAULT
              .labelSuffix
          )}`

      this.pricelist
          .ownerEmail = (
            this.authEmail
          );

      delete (
        this.pricelist
            ._id
      );

      delete (
        this.pricelist
            .currencySymbol
      );

      delete (
        this.pricelist
            .labelHuman
      );
    }
  }

  private setPricelistIsEdit() {
    this.pricelistIsEdit = (
      this.pricelist &&
      !this.pricelistIsClone &&
      !this.pricelistIsMarkup &&
      !this.pricelistIsNew  &&
      (
        this.pricelist
            .isDraft
      ) &&
      (
        this.authEmail ===
        (
          this.pricelist
              .ownerEmail
        )
      )
    );

    if (this.pricelistIsEdit) {
      delete (
        this.pricelist
            .currencySymbol
      );

      delete (
        this.pricelist
            .labelHuman
      );
    }
  }

  private setPricelistIsReadOnly() {
    this.pricelistIsReadOnly = (
      !this.pricelistIsEdit &&
      (
        !(
          this.pricelistIsClone ||
          this.pricelistIsMarkup ||
          this.pricelistIsNew
        )
      )
    );
  }


  private setPricelistDiscount(): boolean {
    let discountRatioMap: RatiosWms | any = (
      this.pricelistIsClone
        ? (
            this.pricelistWmsService.cloneDiscountRatioMap?.[this.pricelist._id]
            || this.pricelistWmsService.markupCostsRatioMap?.[this.pricelist._id]
          )
        : (
            this.pricelistWmsService.cloneDiscountRatioMap?.[this.pricelist._id]
          )
    );

    if (this.pricelistIsClone) {
      this.pricelistWmsService.resetCloneRatioMap(true);
    }

    if (!discountRatioMap) {
      this.showRefreshWarning = false;
      return false;
    }

    if (!discountRatioMap.hasOwnProperty('ratios')) {
      const ratios: { [key: string]: number } = {};

      Object.keys(discountRatioMap).forEach(key => {
        if (typeof discountRatioMap[key] === 'number') {
          ratios[key] = discountRatioMap[key];
        }
      });

      discountRatioMap = {
        ratios,
        currencyCode: discountRatioMap.currencyCode,
        currencyRate: discountRatioMap.currencyRate
      };
    }

    if (
      this.pricelistIsClone &&
      !discountRatioMap.currencyCode
    ) {
      discountRatioMap.currencyCode = this.pricelist.currencyCode;
    }

    this.setPricelistCurrency(discountRatioMap);

    const applyDiscount = (
      fee: number,
      ratioMap: RatiosWms,
      key: string,
      isRatio: boolean = false
    ) => (
      parseFloat(
        (
          fee *
          (
            100 - (ratioMap.ratios[key] || 0)
          ) / 100
        ).toFixed(
          isRatio ? 3 : 2
        )
      )
    );

    this.setPricelistAdjustment(
      discountRatioMap,
      applyDiscount
    );

    return true;
  }

  private setPricelistIncrease() {
    let markupRatioMap: RatiosWms = (
    this.pricelistIsClone ?
        (
          this.pricelistWmsService
              .markupCostsRatioMap[
                this.pricelist
                    ._id
              ]
        ) :
        (
          this.pricelistWmsService
              .markupRatioMap[
                this.pricelist
                    ._id
              ]
        )
    );

    if (this.pricelistIsClone) {
      this.pricelistWmsService
          .resetCloneRatioMap(
            true
          );
    }
    else {
      this.pricelistWmsService
          .resetMarkupRatioMap();
    }

    if (!markupRatioMap) {
      this.showRefreshWarning = false;

      return (
        this.goBack()
      );
    }

    if (
      this.pricelistIsClone &&
      !(
        markupRatioMap
          .currencyCode
      )
    ) {
      markupRatioMap
        .currencyCode = (
          this.pricelist
              .currencyCode
        );
    }


    if (!markupRatioMap.hasOwnProperty('ratios')) {
      const ratios: { [key: string]: number } = {};
  
      Object.keys(markupRatioMap).forEach(key => {
        if (typeof markupRatioMap[key] === 'number') {
          ratios[key] = markupRatioMap[key];  
        }
      });
  
      markupRatioMap = {
        ratios,
        currencyCode: markupRatioMap.currencyCode
      };
    }

    this.setPricelistCurrency(
      markupRatioMap
    );

    const applyIncrease = (
      fee: number,
      ratioMap: RatiosWms,
      key: string,
      isRatio: boolean = false
    ) => (
      parseFloat(
        (
          fee *
          (
            100 +
            (
              ratioMap.ratios[
                key
              ]
            )
          ) /
          100
        ).toFixed(
          isRatio ?
            3 :
            2
        )
      )
    );

    this.setPricelistAdjustment(
      markupRatioMap,
      applyIncrease
    );
  }

  private setPricelistAdjustment(
    ratioMap: RatiosWms,
    applyAdjustment: Function
  ) {
    setPricelistAdjustmentWms(
      this.pricelist,
      ratioMap,
      applyAdjustment
    );
  }

  private setPricelistCurrency(
    markupRatioMap: RatiosWms
  ) {
    const {
      currencyCode,
      currencyRate
    } = markupRatioMap;

    this.setCurrencyOptionActive(
      currencyCode
    );

    if (
      !(
        currencyRate &&
        (
          currencyCode ===
          DEFAULT_CURRENCY_CODE
        )
      )
    ) {
      return false;
    }

    const applyConversion = (
      fee: number,
      ratioMap: RatiosWms,
      key: string,
      isRatio: boolean = false
    ) => (
      isRatio ?
        fee :
        (
          parseFloat(
            (
              fee *
              currencyRate
            )
            .toFixed(
              2
            )
          )
        )
    );

    this.setPricelistAdjustment(
      markupRatioMap,
      applyConversion
    );
  }

  private setRateCurrency() {
    if (
      this.currencyOptionActive &&
      (
        (
          this.currencyOptionActive
              .code
        ) !==
        DEFAULT_CURRENCY_CODE
      )
    ) {
      this.currencyRateFieldShow = (
        this.pricelistDomainIsCosts &&
        !this.pricelistIsMarkup
      );
    }
    else {
      this.currencyRateFieldShow = false;

      this.pricelist
          .rateCurrency = null;
    }
  }

  private setValidTimestampRaw(
    key: string,
    value: string,
    isEndOfDay: boolean = false
  ) {
    if (!this.pricelist) {
      return false;
    }

    this.pricelist[
      key
    ] = (
      getUtcDateTimestamp(
        value,
        isEndOfDay
      )
    );
  }

  private setVatRates() {
    this.vatRates = (
      getVatRates()
    );
  }

  public stopEvent(event: Event) {
    event.stopPropagation();
  }

  public filterEntities(
    entities: any[],
    activeEntities: any[],
    searchTerm: string,
    searchProperties: string[],
    setResult: (result: any[]) => void
  ) {
    if (searchTerm && searchTerm.trim() !== "") {
      const searchTermLower = searchTerm.toLowerCase();
      const filtered = entities.filter(
        entity =>
        searchProperties.some(
          prop =>
          entity[prop].toLowerCase()
          .includes(searchTermLower)
        )
      );
      const uniqueFiltered = [
        ...filtered, 
        ...activeEntities]
        .filter(
        (entity, index, self) =>
          index === self.findIndex(
            e => searchProperties.every(
              prop => e[prop] === entity[prop]
            )
          )
      );
      setResult(uniqueFiltered);
    } else {
      const uniqueEntities = [
        ...entities, 
        ...activeEntities].filter(
        (entity, index, self) =>
          index === self.findIndex(
            e => searchProperties.every(
              prop => e[prop] === entity[prop]
            )
          )
      );
      setResult(uniqueEntities);
    }
    this.cdr.detectChanges();
  }
  
  public filterServices() {
    this.filterEntities(
      this.services,
      this.pricelistServicesActive,
      this.serviceSearchTerm,
      ['codeLegacy', 'label'],
      result => this.filteredServices = result
    );
  }
  
  public filterUsers() {
    this.filterEntities(
      this.users,
      this.pricelistUsersActive,
      this.userSearchTerm,
      ['code', 'organisation'],
      result => this.filteredUsers = result
    );
  }
}
